module.exports = __webpack_public_path__ + "static/media/08PerformancePhotos.590a9a98.jpeg";